export const getGoodScore = (answerOptions: number) => {
    if (answerOptions === 10) {
      return 8;
    } else if (answerOptions === 7) {
      return 6;
    } else if (answerOptions === 3) {
      return 2;
    } else {
      return 4;
    }
}